import { InjectionToken } from '@angular/core';
import { NgxUiLoaderRouterConfig } from '../utils/interfaces';

/**
 * Injection token for ngx-ui-loader-router configuration
 */
export const NGX_UI_LOADER_ROUTER_CONFIG_TOKEN =
  new InjectionToken<NgxUiLoaderRouterConfig>('ngxUiLoaderRouterCustom.config');
